import { isProblemStatus } from '@/services/api';
import type { PublicRecordState } from '@/features/publicsite/types/PublicRecordState';

/** What a public read of one record can be, once the request has been made. */
export const PUBLIC_RECORD = {
  loading: 'LOADING',
  found: 'FOUND',
  /** The server said 404: there is no such record, or it is not published. */
  missing: 'MISSING',
  /** Anything else — a fault, a rate limit, an endpoint this deployment does not serve yet. */
  unavailable: 'UNAVAILABLE',
} as const;

/**
 * Which of the two failures a refused read was.
 *
 * A list can treat every failure alike: it shows nothing either way. A single record cannot,
 * because the two say opposite things to a visitor. "This institution does not exist or is no
 * longer public" is a statement about the institution, and printing it over a rate limit or a
 * fault tells someone a live, published page has been taken down.
 *
 * Only 404 is the record's own answer — and deliberately so on this endpoint, where an
 * unpublished institution and an absent one must be indistinguishable, or the reply would say
 * who has applied.
 */
export function publicRecordState(error: unknown): PublicRecordState {
  return isProblemStatus(error, 404) ? PUBLIC_RECORD.missing : PUBLIC_RECORD.unavailable;
}
